import { OAuthResponseType } from '@okta/okta-auth-js';
import { getConfig } from '../configService';

interface OktaConfig {
  clientId: string;
  issuer: string;
  redirectUri: string;
  scopes: string[];
  pkce: boolean;
  responseType: OAuthResponseType[];
}

export const getOktaConfig = async (): Promise<{ oidc: OktaConfig }> => {
  const config = getConfig();
  const CLIENT_ID = config.REACT_APP_CLIENT_ID;
  const ISSUER = config.REACT_APP_ISSUER;
  const REDIRECT_URI = `${window.location.origin}/login/openid-redirect-uri`;

  const oktaConfig: OktaConfig = {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    // `groups` is load-bearing, not decorative: the supervisor's whole RBAC
    // runs on the ID token's `groups` claim, and on the org authorization
    // server Okta only emits that claim when the scope is requested. Without
    // it every caller looks group-less. Same scopes as the sibling George
    // frontends (conversational-frontend, george-monitoring) against this
    // same client id.
    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
    responseType: ['code'],
  };

  return Promise.resolve({
    oidc: oktaConfig,
  });
};
